import { render, staticRenderFns } from "./DeleteStockOrderReferenceButton.vue?vue&type=template&id=d2b81cf0&"
import script from "./DeleteStockOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./DeleteStockOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports